module.exports = __webpack_public_path__ + "static/media/cartecadeau.77e3eda4.webp";